import { KATANA_PERPS } from '#/config/constants';

import { supportedResolutionsString } from './chartInterval';
import { LibrarySymbolInfo } from './external/charting_library';

export interface ExtendedSymbolInfo extends LibrarySymbolInfo {
  baseSymbol: string;
  quoteSymbol: string;
}

/**
 * https://github.com/tradingview/charting_library/wiki/Symbology#symbolinfo-structure
 * https://github.com/tradingview/charting_library/wiki/JS-Api
 */
export const getSymbolInfo = (
  base: string,
  quote: string,
  visibleDecimals: number,
  timelineGapsTreatment?: 'hideEmptyTimeGap'
): ExtendedSymbolInfo => {
  return {
    name: `${base}/${quote}`,
    base_name: [`${base}/${quote}`],
    description: base + ' Token',
    session: '24x7',
    exchange: KATANA_PERPS,
    listed_exchange: KATANA_PERPS,
    data_status: 'streaming',
    timezone: 'Etc/UTC',
    minmov: 1,
    // fractional: true,
    pricescale: 10 ** visibleDecimals,
    has_intraday: true,
    intraday_multipliers: supportedResolutionsString,
    format: 'price',
    has_seconds: true,
    seconds_multipliers: ['1'],
    has_daily: true,
    has_weekly_and_monthly: false,
    /** When `true` chart will hide time gaps. Eg. for non-weekend markets */
    has_empty_bars: timelineGapsTreatment !== 'hideEmptyTimeGap',
    volume_precision: 2,
    expired: false,
    currency_code: base,
    // Our custom properties
    baseSymbol: base,
    quoteSymbol: quote,
    type: 'token',
    supported_resolutions: supportedResolutionsString,
  };
};
